import { requestWithToken } from '../utilities/request';

/**
 * CCUS事業者情報取得開始API
 * @param {object} params
 * */
const beginFetchCcusCompanyData = params => {
  return requestWithToken(
    {
      method: 'GET',
      url: '/api/private/ccus/company/begin_fetch',
      params,
    },
    true,
    false
  );
};

/**
 * CCUS事業者情報取得API
 * @param {object} params
 * */
const fetchCcusCompanyData = params => {
  return requestWithToken(
    {
      method: 'GET',
      url: '/api/private/ccus/company/fetch',
      params,
    },
    true,
    false
  );
};

export const PartnerCompanyCcusService = {
  beginFetchCcusCompanyData,
  fetchCcusCompanyData,
};
export default PartnerCompanyCcusService;



// WEBPACK FOOTER //
// ./src/services/PartnerCompanyCcus.js